import { render } from "./CtaPhone.vue?vue&type=template&id=0334f8ac"
import script from "./CtaPhone.vue?vue&type=script&lang=js"
export * from "./CtaPhone.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__